<template>
  <div class="subtest">
    <div class="one-product-img">
      <img :src="subtest.test_type.icon_path" :alt="subtest.test_type.name">
    </div>
    <div class="one-product-right">
      <div class="one-product-content">
        <div>
          <h5>
            {{ subtestTitle }}
          </h5>
          <icons :subtest="subtest"></icons>
          <p>
            {{ translate('create-subtest-attempt.subtest.' + subtest.subtest_type.name + '_description') }}
          </p>
        </div>
        <div>
          <div class="sum-product">€ {{ subtest.price }}</div>
        </div>
        <div>
          <button class="btn btn-primary" @click="selectSubtest(subtest)">
            {{ translate('create-subtest-attempt.subtest.button') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['subtest'],

  computed: {
    subtestTitle () {
      return this.translate('create-subtest-attempt.subtest.title') + ' ' +
        this.subtest.test_type.title + ' ' + this.testType;
    },

    testType () {
      if (this.subtest.subtest_type_id === 3) {
        return 'Schriftlich';
      }

      if (this.subtest.subtest_type_id === 4) {
        return 'Mündlich';
      }

      return 'Gesamt';
    }
  },

  methods: {
    selectSubtest (subtest) {
      this.$parent.$emit('selectSubtest', subtest);
    },
  },
};
</script>

<style scoped>
.one-product-content > div {
    padding: 8px 0 10px;
}
</style>
